export default "__VITE_ASSET__BrbCGRsq__"